export const investigationAiJobs = [
  {
    key: 'connect',
    title: 'Connect',
    icon: 'bi bi-diagram-3',
    description: 'Compare new information with prior machine evidence.',
  },
  {
    key: 'organize',
    title: 'Organize',
    icon: 'bi bi-layers',
    description: 'Separate what is known, possible causes, and unanswered questions.',
  },
  {
    key: 'update',
    title: 'Update',
    icon: 'bi bi-arrow-repeat',
    description: 'Revise where things stand when the evidence changes.',
  },
  {
    key: 'preserve',
    title: 'Preserve',
    icon: 'bi bi-cpu',
    description: 'Carry learning across workers and shifts.',
  },
  {
    key: 'accelerate',
    title: 'Accelerate',
    icon: 'bi bi-forward',
    description: 'Help the next person understand the problem without reconstructing everything manually.',
  },
] as const;

export function InvestigationAiRoleLearning() {
  return (
    <section className="r42-investigation-ai-model" aria-labelledby="r42-investigation-ai-model-title">
      <div className="r42-investigation-ai-model__intro">
        <span className="r42-eyebrow">Team + Route42</span>
        <h2 id="r42-investigation-ai-model-title">Your team solves the problem. Route42 helps them do it faster.</h2>
        <p>People contribute observations, evidence, actions, and professional judgment. Route42 keeps that work connected as the Investigation evolves.</p>
      </div>
      <div className="r42-investigation-ai-jobs" aria-label="Route42 jobs in an Investigation">
        {investigationAiJobs.map((job) => (
          <article key={job.key} className="r42-investigation-ai-job">
            <span className="r42-investigation-ai-job__icon" aria-hidden="true"><i className={job.icon} /></span>
            <div>
              <h3>{job.title}</h3>
              <p>{job.description}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export function InvestigationAiRoleStrip() {
  return (
    <aside className="r42-investigation-ai-strip" aria-label="How Route42 helps this Investigation">
      <span className="r42-investigation-ai-strip__icon" aria-hidden="true"><i className="bi bi-stars" /></span>
      <div>
        <strong>Your team solves the problem. Route42 helps them do it faster.</strong>
        <p><b>Connect</b> evidence · <b>Organize</b> what is known · <b>Update</b> shared understanding · <b>Preserve</b> learning · <b>Accelerate</b> the next useful action.</p>
      </div>
    </aside>
  );
}
